import React from 'react';
import { useIntl } from 'umi';

import SwitchCollapse from '@/pages/datalab/components/SwitchCollapse';

interface IGeneralFilterSectionProps {
  visible?: boolean;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

const GeneralFilterSection: React.FC<IGeneralFilterSectionProps> = (props) => {
  const { visible=true, open, onOpenChange } = props;
  const { formatMessage } = useIntl();

  if (!visible) {
    return null;
  }

  return (
    <SwitchCollapse
      title={formatMessage({ id: 'dbl_filter_general_filter' })}
      defaultOpen={open}
      onOpenChange={onOpenChange}
    />
  );
};

export default GeneralFilterSection;

